import { useFilterContext } from '../contexts/FilterProvider';

export const useRequestGeographyTaxonomyId = (): number => {
  const { geographyTaxonomyId } = useFilterContext();
  return geographyTaxonomyId;
};
